import { useMemo } from "react";

import { TestQuestionData } from '../../types';

type AnswerInputType = number | number[] | undefined;

interface VisibilityHookProps {
  answerInput: AnswerInputType,
  currentQuestion?: TestQuestionData,
}

export const useTestInputVisibility = ({
  answerInput,
  currentQuestion,
}: VisibilityHookProps) => {

  const isVisibleInput = useMemo(() => {
    const { triggerVariants } = currentQuestion || {};

    if (!triggerVariants || triggerVariants === '') {
      return false;
    }

    const triggersArray = triggerVariants
      .split('|')
      .map((elem) => elem === '1');

    if (Array.isArray(answerInput)) {
      return answerInput.some((index) => triggersArray[ index ] === true);
    }

    if (typeof answerInput === 'number' && answerInput >= 0) {
      return triggersArray[ answerInput ] === true;
    }

    return false;

  }, [ answerInput, currentQuestion ]);

  return isVisibleInput;
};